var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 17.7082C14.2585 17.7082 17.7096 14.257 17.7096 9.99984C17.7096 5.74264 14.2585 2.2915 10.0013 2.2915C5.74411 2.2915 2.29297 5.74264 2.29297 9.99984C2.29297 14.257 5.74411 17.7082 10.0013 17.7082Z",
    stroke: "#DCDCEC",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.84424V14.0109",
    stroke: "#DCDCEC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 8.07308C10.5779 8.07308 11.0443 7.60671 11.0443 7.03141C11.0443 6.45612 10.5779 5.98975 10.0026 5.98975C9.42731 5.98975 8.96094 6.45612 8.96094 7.03141C8.96094 7.60671 9.42731 8.07308 10.0026 8.07308Z",
    fill: "#DCDCEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainInfo);
export default __webpack_public_path__ + "static/media/main_info.19c47e9615534866d9fd3a85cc140d03.svg";
export { ForwardRef as ReactComponent };